/* eslint-disable */
import { Modal, Select, Spin, Tooltip, Button, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { BasicFormWrapper } from '../styled';
import { AddProductForm } from '../service/Style';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
    BASEURL,
    IG_APP_ID,
    SERVICES,
    options,
    urlRegex,
} from '../../helpers/constants';
import {
    delImage,
    getDetails,
    resetInstaFiles,
    updateDetails,
} from '../../redux/businessAccount/detailsAction';
import {
    cancelStripeSubscription,
    fetchStripeSubscriptionStatus,
    resumeStripeSubscription,
    changePaymentMethod,
} from '../../redux/businessAccount/stripeAction';
import { getCustomerDetails } from '../../redux/users/actionCreator';
import { useDispatch } from 'react-redux';
import { Autocomplete } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import TextArea from 'antd/lib/input/TextArea';
import Loading from '../../components/Loading';
import SVG from '../steps/SVG';
import axios from 'axios';
import Navbar from '../Navbar';
import { axiosInstance } from '../../repository/Repository';
import UploadFromInsta from './UploadFromInsta';
import { useRef } from 'react';
import { plusIcon } from '../../assets/images/sidebarIcons';
import moment from 'moment';
import { StopOutlined } from '@ant-design/icons';
import { fetchAllBusinessNames } from '../../redux/services/servicesActions';
import ImageResize from 'quill-image-resize-module-react';
import Quill from 'quill';
import ChangeCardModal from './components/ChangeCardModal';
import SubscriptionSection from './components/SubscriptionSection';
import OnlineLinksSection from './components/OnlineLinksSection';
import BookingPolicySection from './components/BookingPolicySection';

Quill.register('modules/imageResize', ImageResize);

const Setting = () => {
    const {
        businessDetails,
        updateLoading,
        fetchLoading,
        instaImgFiles,
        subscriptionStatus,
        subscriptionStatusLoading,
        resumeSubscriptionLoading,
        cancelSubscriptionLoading,
    } = useSelector((state) => state.businessDetails);
    const { businessNames } = useSelector((state) => state.services);
    const { userData } = useSelector((state) => state.user);
    const [name, setName] = useState('');
    const [about, setAbout] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [images, setImages] = useState([]);
    const [location, setLocation] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [fb, setFb] = useState('');
    const [insta, setInsta] = useState('');
    const [website, setWebsite] = useState('');
    const [routine, setRoutine] = useState({});
    const [data, setData] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [applyAll, setApplyAll] = useState(false);
    const [selectedServices, setSelectedServices] = useState([]);
    const [isOnline, setIsOnline] = useState(false);
    const [isChangeCardModalVisible, setIsChangeCardModalVisible] =
        useState(false);
    const [errors, setErrors] = useState({});
    const [cancellationType, setCancellationType] = useState('Moderate');
    const [policies, setPolicies] = useState('');
    const [bookingPeriod, setBookingPeriod] = useState(null);
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] =
        useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
    const dispatch = useDispatch();
    const [isCancellationTypeOpen, setCancellationTypeOpen] = useState(false);
    const cancellationRef = useRef(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const [bufferTime, setBufferTime] = useState(null);
    const [depositPercentage, setDepositPercentage] = useState(0);
    const [paymentMethods, setPaymentMethods] = useState('card'); // 'card', 'cash', or 'both'
    const subscriptionInfo = subscriptionStatus || {};
    const currentPlan = subscriptionInfo?.currentPlan || null;
    const subscriptionEndDate = subscriptionInfo?.periodEnd
        ? moment(subscriptionInfo?.periodEnd).format('DD MMM YYYY')
        : subscriptionInfo?.subscription?.expired_at
        ? moment
              .unix(subscriptionInfo?.subscription?.expired_at)
              .format('DD MMM YYYY')
        : 'N/A';
    const subscriptionStatusLabel =
        subscriptionInfo?.status === 'cancel_scheduled'
            ? 'Subscription Cancelled'
            : subscriptionInfo?.status === 'downgrade_scheduled'
            ? 'Downgrade scheduled'
            : subscriptionInfo?.status === 'no_subscription'
            ? 'No subscription'
            : 'Active';

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image'],
            ['clean'],
        ],
        imageResize: {
            modules: ['Resize', 'DisplaySize'],
        },
    };

    const formats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'list',
        'bullet',
        'link',
        'image',
    ];

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                cancellationRef.current &&
                !cancellationRef.current.contains(event.target)
            ) {
                setCancellationTypeOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const cancellationTypes = [
        {
            title: 'strict',
            description: 'Deposit is non-refundable',
        },
        {
            title: 'moderate',
            description:
                'Free cancellation up to 48 hours before the appointment.',
        },
        {
            title: 'flexible',
            description:
                'Free cancellation up to 24 hours before the appointment.',
        },
    ];
    const toggleCancellationType = () => {
        setCancellationTypeOpen(!isCancellationTypeOpen);
    };

    const handlePaymentMethodToggle = (method) => {
        setPaymentMethods(method);
    };

    const handleLocationLatLng = () => {
        const place = data.getPlace();
        setLocation(place?.formatted_address);
        const lat = place?.geometry?.location?.lat();
        const lng = place?.geometry?.location?.lng();
        setLatitude(lat);
        setLongitude(lng);
    };

    const filteredOptions = options.filter((country) =>
        country.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCountryCodeClick = (_country) => {
        setCountryCode(_country.code);
    };

    const handleImageChange = (e) => {
        const files = e.target.files;
        const updatedImages = [...images];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileSize = file.size;
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!allowedTypes.includes(file.type)) {
                setErrors((prev) => ({
                    ...prev,
                    images: 'You can only upload an image file (JPEG, PNG, JPG)',
                }));
                e.target.value = '';
                return;
            }
            if (fileSize > 20000000) {
                setErrors((prev) => ({
                    ...prev,
                    images: 'File size exceeds 20 megabytes',
                }));
                e.target.value = '';
                return;
            }
            const previewPic = URL.createObjectURL(file);
            updatedImages.push({ file, previewPic });
        }
        setImages(updatedImages);
    };

    const handleIsOnline = (e) => {
        let checked = e.target.checked;
        if (checked) {
            setIsOnline(true);
            setLocation('');
            setLatitude('');
            setLongitude('');
        } else {
            setIsOnline(checked);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});

        const normalize = (str) => str.toLowerCase().replace(/\s+/g, '-');
        const normalizedBusinessNames = businessNames.map(normalize);
        const normalizedNewName = normalize(name);

        // Validate URLs
        const [website_valid, fb_valid, insta_valid] = await Promise.all([
            website ? urlRegex.test(website) : true,
            fb ? urlRegex.test(fb) : true,
            insta ? urlRegex.test(insta) : true,
        ]);

        let hasError = false;
        const newErrors = {};

        const existingBusinessName = userData?.business?.name || '';
        if (!name) {
            newErrors.name = 'Business name is required';
            hasError = true;
        } else if (
            normalize(existingBusinessName) !== normalizedNewName &&
            normalizedBusinessNames.includes(normalizedNewName)
        ) {
            newErrors.name = 'This business name already exists.';
            hasError = true;
        }

        if (!phone) {
            newErrors.phone = 'Contact Number is required';
            hasError = true;
        } else if (phone.length < 6 || phone.length > 14) {
            newErrors.phone = 'Mobile number must be between 6 to 14 digits';
            hasError = true;
        }

        if (selectedServices.length < 1) {
            newErrors.services = 'Select at least 1 service';
            hasError = true;
        }

        if (!website_valid) {
            newErrors.website =
                "Provide valid URL 'https://www.yourwebsite.com'";
            hasError = true;
        }
        if (!fb_valid) {
            newErrors.fb =
                "Provide valid URL 'https://www.facebook.com/yourpage'";
            hasError = true;
        }
        if (!insta_valid) {
            newErrors.insta =
                "Provide valid URL 'https://www.instagram.com/yourpage'";
            hasError = true;
        }

        if (hasError) {
            setErrors(newErrors);
            return;
        }

        setErrors({});

        const formData = new FormData();
        formData.append('name', name);
        formData.append('about', about);
        formData.append('phone', countryCode + '-' + phone);
        formData.append('address', location);
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('facebook', fb);
        formData.append('Instagram', insta);
        formData.append('website', website);
        formData.append(
            'bookingPeriod',
            bookingPeriod === null ||
                bookingPeriod === undefined ||
                bookingPeriod === 'null'
                ? ''
                : bookingPeriod
        );
        formData.append('policies', policies);
        formData.append('bufferTime', bufferTime);
        formData.append('depositPercentage', depositPercentage ?? 0);
        formData.append('cancellationType', cancellationType);
        formData.append('paymentMethod', paymentMethods);

        Object.entries(routine).forEach(([day, times]) => {
            if (times.isOpened && (times.from == null || times.to == null)) {
                toast.error(
                    'You must add "From" and "To" timings for open days'
                );
                hasError = true;
                return;
            }

            if (typeof times === 'object' && times !== null) {
                Object.entries(times).forEach(([key, value]) => {
                    if (key === 'blockedTimes' && Array.isArray(value)) {
                        value.forEach((block, index) => {
                            formData.append(
                                `openingTimes[${day}][blockedTimes][${index}][from]`,
                                block.from
                            );
                            formData.append(
                                `openingTimes[${day}][blockedTimes][${index}][to]`,
                                block.to
                            );
                        });
                    } else {
                        formData.append(`openingTimes[${day}][${key}]`, value);
                    }
                });
            }
        });

        if (images.length === 0) {
            toast.error(
                'Please upload at least one image related to your business.'
            );
            return;
        }
        images.forEach((item) => {
            formData.append('images', item.file);
        });

        selectedServices.forEach((item, index) => {
            formData.append(`categories[${index}]`, item);
        });

        if (hasError) {
            return;
        }

        dispatch(updateDetails(formData))
            .then((res) => {
                if (
                    res &&
                    (res.success || res.status === 'success' || !res.error)
                ) {
                    toast.success('Business info updated successfully');
                    dispatch(getDetails()).catch((error) => console.log(error));
                } else {
                    toast.error(
                        res?.message || 'Error updating business details'
                    );
                }
            })
            .catch((error) => {
                const errMsg =
                    error?.response?.data?.message ||
                    error?.message ||
                    'Error updating business details';
                toast.error(errMsg);
            });
    };

    const handleRemoveImage = (id, index) => {
        const updatedImages = [...images];

        if (id) {
            if (images.length === 1) {
                toast.error('At least one business image is mendatory.');
                return;
            } else {
                dispatch(delImage(id))
                    .then((res) => {
                        if (res.success) {
                            // updatedImages.splice(index, 1);
                            // setImages(updatedImages);
                            dispatch(getDetails());
                            toast.success('Image deleted successfully');
                        }
                    })
                    .catch((error) => {
                        toast.error('Error deleting image');
                    });
            }
        } else {
            updatedImages.splice(index, 1);
            setImages(updatedImages);
        }
    };

    const handleServiceChange = (name) => {
        const updatedServices = selectedServices.includes(name)
            ? selectedServices.filter((_name) => _name !== name)
            : [...selectedServices, name];

        setSelectedServices(updatedServices);
    };

    const handleCancelSubscription = async () => {
        try {
            if (!userData?.email) return;
            setIsCancelling(true);
            await dispatch(cancelStripeSubscription(userData.email));
            setIsSubscriptionModalOpen(false);
            setIsCancelling(false);
        } catch (error) {
            setIsCancelling(false);
            toast.error(
                error?.response?.data?.message ||
                    'Unable to cancel subscription'
            );
        }
    };

    const handleResumeSubscription = async () => {
        try {
            if (!userData?.email) return;
            setIsCancelling(true);
            await dispatch(resumeStripeSubscription(userData.email));
            setIsCancelling(false);
        } catch (error) {
            setIsCancelling(false);
            toast.error(
                error?.response?.data?.message ||
                    'Unable to resume subscription'
            );
        }
    };

    const handleRoutine = (dayOfWeek) => {
        const handleSelectChange = (dayOfWeek, field, value) => {
            setRoutine((prevRoutine) => {
                const updatedRoutine = { ...prevRoutine };

                if (applyAll && (field === 'from' || field === 'to')) {
                    updatedRoutine[dayOfWeek][field] = value;
                    Object.keys(updatedRoutine).forEach((day) => {
                        if (day !== dayOfWeek && updatedRoutine[day].isOpened) {
                            updatedRoutine[day][field] = value;
                        }
                    });
                } else {
                    updatedRoutine[dayOfWeek][field] = value;
                    if (field === 'isOpened') {
                        if (!value) {
                            updatedRoutine[dayOfWeek].from = null;
                            updatedRoutine[dayOfWeek].to = null;
                            updatedRoutine[dayOfWeek].blockedTimes = [];
                        } else {
                            if (!updatedRoutine[dayOfWeek].from || updatedRoutine[dayOfWeek].from === 'null') {
                                updatedRoutine[dayOfWeek].from = '10:00';
                            }
                            if (!updatedRoutine[dayOfWeek].to || updatedRoutine[dayOfWeek].to === 'null') {
                                updatedRoutine[dayOfWeek].to = '20:00';
                            }
                        }
                    }
                }
                return updatedRoutine;
            });
        };

        const showModal = (dayOfWeek) => {
            setSelectedDay(dayOfWeek);
            setIsModalVisible(true);
        };

        const handleBlockTimeChange = (index, field, value) => {
            setRoutine((prevRoutine) => {
                const updatedRoutine = { ...prevRoutine };
                if (!updatedRoutine[selectedDay].blockedTimes) {
                    updatedRoutine[selectedDay].blockedTimes = [];
                }

                updatedRoutine[selectedDay].blockedTimes[index] = {
                    ...updatedRoutine[selectedDay].blockedTimes[index],
                    [field]: value,
                };

                if (applyAll) {
                    const sourceBlockedTimes = JSON.parse(JSON.stringify(updatedRoutine[selectedDay].blockedTimes));
                    Object.keys(updatedRoutine).forEach((day) => {
                        if (day !== selectedDay && updatedRoutine[day].isOpened) {
                            updatedRoutine[day].blockedTimes = JSON.parse(JSON.stringify(sourceBlockedTimes));
                        }
                    });
                }

                return updatedRoutine;
            });
        };

        const addBlockTime = () => {
            setRoutine((prevRoutine) => {
                const updatedRoutine = { ...prevRoutine };
                if (!updatedRoutine[selectedDay].blockedTimes) {
                    updatedRoutine[selectedDay].blockedTimes = [];
                }

                updatedRoutine[selectedDay].blockedTimes.push({
                    from: null,
                    to: null,
                });

                if (applyAll) {
                    const sourceBlockedTimes = JSON.parse(JSON.stringify(updatedRoutine[selectedDay].blockedTimes));
                    Object.keys(updatedRoutine).forEach((day) => {
                        if (day !== selectedDay && updatedRoutine[day].isOpened) {
                            updatedRoutine[day].blockedTimes = JSON.parse(JSON.stringify(sourceBlockedTimes));
                        }
                    });
                }

                return updatedRoutine;
            });
        };

        const removeBlockTime = (index) => {
            setRoutine((prevRoutine) => {
                const updatedRoutine = { ...prevRoutine };
                updatedRoutine[selectedDay].blockedTimes.splice(index, 1);

                if (applyAll) {
                    const sourceBlockedTimes = JSON.parse(JSON.stringify(updatedRoutine[selectedDay].blockedTimes));
                    Object.keys(updatedRoutine).forEach((day) => {
                        if (day !== selectedDay && updatedRoutine[day].isOpened) {
                            updatedRoutine[day].blockedTimes = JSON.parse(JSON.stringify(sourceBlockedTimes));
                        }
                    });
                }

                return updatedRoutine;
            });
        };

        const handleOk = () => {
            setIsModalVisible(false);
        };

        const handleCancel = () => {
            setIsModalVisible(false);
        };

        const dayBlockedTimes = routine[dayOfWeek]?.blockedTimes || [];
        const hasBlockedTimes = dayBlockedTimes.some(
            (slot) => slot.from && slot.to
        );

        return (
            <div
                key={dayOfWeek}
                className="d-flex align-items-start justify-content-start gap-3 mb-2 flex-wrap w-100"
            >
                <h6
                    className="f-14 mb-0 fw-normal poppins text-gray pt-1"
                    style={{ width: 80, textAlign: 'left' }}
                >
                    {dayOfWeek}
                </h6>
                <div className="d-flex flex-column align-items-start">
                    <div className="d-flex gap-2 align-items-center flex-wrap">
                        <Select
                            placeholder="From"
                            className="f-14 mb-3"
                            size="small"
                            value={routine[dayOfWeek]?.isOpened}
                            onChange={(value) =>
                                handleSelectChange(dayOfWeek, 'isOpened', value)
                            }
                        >
                            <Select.Option value={true}>Opened</Select.Option>
                            <Select.Option value={false}>Closed</Select.Option>
                        </Select>
                        {routine[dayOfWeek]?.isOpened && (
                            <>
                                <Select
                                    style={{ width: 84 }}
                                    className="f-14 py-0 mb-3"
                                    placeholder="From"
                                    size="small"
                                    value={routine[dayOfWeek]?.from === 'null' ? null : (routine[dayOfWeek]?.from || null)}
                                    onChange={(value) =>
                                        handleSelectChange(
                                            dayOfWeek,
                                            'from',
                                            value
                                        )
                                    }
                                >
                                    {Array.from(
                                        { length: 24 },
                                        (_, i) => i + 1
                                    ).map((hour) => (
                                        <Select.Option
                                            key={hour}
                                            className="f-14"
                                            value={`${hour}:00`}
                                        >
                                            {`${hour}:00`}
                                        </Select.Option>
                                    ))}
                                </Select>
                                <Select
                                    style={{ minWidth: 84 }}
                                    className="f-14 mb-3"
                                    placeholder="To"
                                    size="small"
                                    value={routine[dayOfWeek]?.to === 'null' ? null : (routine[dayOfWeek]?.to || null)}
                                    onChange={(value) =>
                                        handleSelectChange(
                                            dayOfWeek,
                                            'to',
                                            value
                                        )
                                    }
                                >
                                    {Array.from(
                                        { length: 24 },
                                        (_, i) => i + 1
                                    ).map((hour) => (
                                        <Select.Option
                                            key={hour}
                                            className="f-14"
                                            value={`${hour}:00`}
                                        >
                                            {`${hour}:00`}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </>
                        )}
                        {routine[dayOfWeek]?.isOpened && (
                            <Tooltip title="Block Specific Hours in Week">
                                <Button
                                    type="text"
                                    danger
                                    icon={
                                        <StopOutlined
                                            style={{ fontSize: '15px' }}
                                        />
                                    }
                                    className="d-flex align-items-center justify-content-center ms-2 block-time-btn"
                                    onClick={() => showModal(dayOfWeek)}
                                    style={{
                                        borderColor: '#ffccc7',
                                        backgroundColor: '#fff1f0',
                                        color: '#ff4d4f',
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '6px',
                                        border: '1px solid #ffccc7',
                                        marginBottom: '1rem',
                                    }}
                                />
                            </Tooltip>
                        )}
                    </div>
                    <Modal
                        title={
                            <span
                                style={{
                                    fontFamily: 'Poly, serif',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    color: '#0f151d',
                                }}
                            >
                                Block Time Slot for {selectedDay}
                            </span>
                        }
                        visible={isModalVisible}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        mask={false}
                        centered
                        footer={[
                            <Button
                                key="done"
                                type="primary"
                                onClick={handleOk}
                                style={{
                                    backgroundColor: '#2b5c35',
                                    borderColor: '#2b5c35',
                                    color: '#fff',
                                    borderRadius: '6px',
                                    height: '38px',
                                    padding: '0 24px',
                                    fontWeight: '500',
                                }}
                            >
                                Done
                            </Button>,
                        ]}
                    >
                        {routine[selectedDay]?.blockedTimes?.map(
                            (slot, index) => {
                                let blockedHours = new Set();
                                routine[selectedDay]?.blockedTimes.forEach(
                                    ({ from, to }) => {
                                        if (from && to) {
                                            const start = parseInt(from);
                                            const end = parseInt(to);
                                            for (let i = start; i <= end; i++) {
                                                blockedHours.add(`${i}:00`);
                                            }
                                        }
                                    }
                                );

                                return (
                                    <div
                                        key={index}
                                        className="d-flex gap-2 align-items-center mb-2"
                                    >
                                        <Select
                                            style={{ width: '45%' }}
                                            placeholder="From"
                                            value={slot.from || null}
                                            onChange={(value) =>
                                                handleBlockTimeChange(
                                                    index,
                                                    'from',
                                                    value
                                                )
                                            }
                                        >
                                            {Array.from(
                                                { length: 24 },
                                                (_, i) => `${i + 1}:00`
                                            )
                                                .filter(
                                                    (hour) =>
                                                        !blockedHours.has(
                                                            hour
                                                        ) || hour === slot.from
                                                )
                                                .map((hour) => (
                                                    <Select.Option
                                                        key={`from-${hour}`}
                                                        value={hour}
                                                    >
                                                        {hour}
                                                    </Select.Option>
                                                ))}
                                        </Select>
                                        <Select
                                            style={{ width: '45%' }}
                                            placeholder="To"
                                            value={slot.to || null}
                                            onChange={(value) =>
                                                handleBlockTimeChange(
                                                    index,
                                                    'to',
                                                    value
                                                )
                                            }
                                        >
                                            {Array.from(
                                                { length: 24 },
                                                (_, i) => `${i + 1}:00`
                                            )
                                                .filter((hour) => {
                                                    const fromHour = slot.from
                                                        ? parseInt(slot.from)
                                                        : 0;
                                                    return (
                                                        parseInt(hour) >
                                                            fromHour &&
                                                        !blockedHours.has(hour)
                                                    );
                                                })
                                                .map((hour) => (
                                                    <Select.Option
                                                        key={`to-${hour}`}
                                                        value={hour}
                                                    >
                                                        {hour}
                                                    </Select.Option>
                                                ))}
                                        </Select>
                                        <button
                                            className="btn btn-sm d-flex align-items-center justify-content-center"
                                            onClick={() =>
                                                removeBlockTime(index)
                                            }
                                            style={{
                                                backgroundColor: '#fff1f0',
                                                border: '1px solid #ffccc7',
                                                color: '#ff4d4f',
                                                width: '32px',
                                                height: '32px',
                                                borderRadius: '6px',
                                                fontSize: '18px',
                                                lineHeight: '1',
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                );
                            }
                        )}

                        <button
                            className="btn w-100 mt-3 d-flex align-items-center justify-content-center gap-2"
                            onClick={addBlockTime}
                            type="button"
                            disabled={routine[selectedDay]?.blockedTimes?.some(
                                (slot) => !slot.from || !slot.to
                            )}
                            style={{
                                backgroundColor: '#fff',
                                border: '1px dashed #2b5c35',
                                color: '#2b5c35',
                                borderRadius: '8px',
                                height: '38px',
                                fontWeight: '500',
                            }}
                        >
                            + Add Blocked Time
                        </button>
                    </Modal>
                    {routine[dayOfWeek]?.isOpened && hasBlockedTimes && (
                        <div className="d-flex flex-wrap gap-2 mt-1 mb-2">
                            {dayBlockedTimes
                                .filter((slot) => slot.from && slot.to)
                                .map((slot, idx) => (
                                    <span
                                        key={idx}
                                        className="badge poppins f-11 fw-normal d-inline-flex align-items-center gap-1"
                                        style={{
                                            backgroundColor: '#fff1f0',
                                            border: '1px solid #ffccc7',
                                            color: '#ff4d4f',
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        <span style={{ fontSize: '10px' }}>
                                            🚫
                                        </span>{' '}
                                        Blocked: {slot.from} - {slot.to}
                                    </span>
                                ))}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    useEffect(() => {
        dispatch(getDetails());
        dispatch(fetchAllBusinessNames());
    }, []);

    useEffect(() => {
        if (userData?.email) {
            dispatch(fetchStripeSubscriptionStatus(userData.email));
        }
    }, [dispatch, userData?.email]);

    useEffect(() => {
        setBookingPeriod(businessDetails?.business?.bookingPeriod ?? '');
        setCancellationType(
            businessDetails?.business?.cancellationType || 'moderate'
        );
        setPolicies(businessDetails?.business?.policies || '');
        setName(businessDetails?.business?.name || '');
        setAbout(businessDetails?.business?.about || '');
        setEmail(businessDetails?.email || '');
        setLocation(businessDetails?.business?.address || '');
        setLatitude(businessDetails?.business?.latitude || '');
        setLongitude(businessDetails?.business?.longitude || '');
        setPhone(businessDetails?.phone.split('-')[1] || '');
        setCountryCode(businessDetails?.phone.split('-')[0] || '+42');
        setWebsite(businessDetails?.business?.website || '');
        setBufferTime(businessDetails?.business?.bufferTime || '');
        setFb(businessDetails?.business?.facebook || '');
        setInsta(businessDetails?.business?.Instagram || '');
        setImages(businessDetails?.business?.pictures || []);
        setDepositPercentage(businessDetails?.business?.depositPercentage ?? 0);
        setPaymentMethods(businessDetails?.business?.paymentMethod || 'card');
        if (instaImgFiles && instaImgFiles.length > 0) {
            setImages((prev) => [...prev, ...instaImgFiles]);
        }
        setSelectedServices(businessDetails?.business?.categories || []);
        setIsOnline(
            businessDetails?.business?.address === '' &&
                businessDetails?.business?.latitude === '' &&
                businessDetails?.business?.longitude === ''
                ? true
                : false
        );
        setRoutine(
            businessDetails?.business?.openingTimes
                ? Object.fromEntries(
                      Object.entries(
                          businessDetails?.business?.openingTimes
                      ).map(([day, times]) => [
                          day,
                          {
                              from: times?.from === 'null' ? null : (times?.from || null),
                              to: times?.to === 'null' ? null : (times?.to || null),
                              isOpened: times?.isOpened === 'true',
                              blockedTimes: Array.isArray(times?.blockedTimes)
                                  ? times.blockedTimes.map((block) => ({
                                        from: block.from || null,
                                        to: block.to || null,
                                    }))
                                  : [],
                          },
                      ])
                  )
                : {
                      Sunday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Monday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Tuesday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Wednesday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Thursday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Friday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                      Saturday: {
                          from: null,
                          to: null,
                          isOpened: false,
                          blockedTimes: [],
                      },
                  }
        );

        setTimeout(() => {
            dispatch(resetInstaFiles());
        }, 4000);
    }, [businessDetails]);

    // ======================
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [accessToken, setAccessToken] = useState('');
    const [instaImages, setInstaImages] = useState([]);
    const path = window.location.pathname;

    const getInstagramAccessTokenFromResponse = (responseData) => {
        const data = responseData?.data;
        if (Array.isArray(data)) {
            return data[0]?.access_token || '';
        }
        return (
            responseData?.access_token ||
            data?.access_token ||
            responseData?.response?.access_token ||
            ''
        );
    };

    // GET Images From Instagram
    useEffect(() => {
        if (path.includes('upload-from-instagram')) {
            const exchangeCodeForToken = async (code) => {
                try {
                    const response = await axiosInstance.post(
                        'instagram/token',
                        {
                            code,
                        }
                    );
                    const accessToken = getInstagramAccessTokenFromResponse(
                        response?.data
                    );
                    if (!accessToken) {
                        toast.error(
                            'Instagram token exchange succeeded but no access token was returned.'
                        );
                        return;
                    }
                    setAccessToken(accessToken);
                    sessionStorage.setItem(`ig_code_used_${code}`, '1');
                    window.history.replaceState(
                        {},
                        document.title,
                        window.location.pathname
                    );
                } catch (error) {
                    const serverError = error?.response?.data;
                    toast.error(
                        serverError?.message ||
                            serverError?.errorCode ||
                            'Unable to connect Instagram right now. Please try again.'
                    );
                }
            };

            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            if (code) {
                if (sessionStorage.getItem(`ig_code_used_${code}`)) {
                    toast.error(
                        'This Instagram authentication code is already used. Please reconnect Instagram.'
                    );
                    return;
                }
                exchangeCodeForToken(code);
            } else {
                toast.error(
                    'Instagram redirect is missing an authorization code. Please reconnect.'
                );
            }
        }
    }, [path]);

    useEffect(() => {
        const fetchUserImages = async () => {
            try {
                const response = await axios.get(
                    `https://graph.instagram.com/me/media?fields=id,media_type,media_url,thumbnail_url&access_token=${accessToken}`
                );
                let images = response.data.data;
                let filteredImages = images.filter(
                    (item) => item.media_type === 'IMAGE'
                );
                setInstaImages(filteredImages);
                setIsModalOpen(true);
            } catch (error) {
                toast.error(
                    'Unable to fetch Instagram media. Please reconnect and try again.'
                );
                console.error('Error fetching user images:', error);
            }
        };

        if (accessToken) {
            fetchUserImages();
        }
    }, [accessToken]);

    // ===========================

    const capitalizeFirstLetter = (string) => {
        if (!string) return string;
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const handleCopyClick = async () => {
        let url = userData
            ? `${window.location.origin}/register?referral=${userData?.id}`
            : window.location.href;
        navigator.clipboard.writeText(url);
        toast.success('Referral link copied');
    };
    const handleShareProfile = async () => {
        const businessId =
            userData?.business?.id || businessDetails?.business?.id;

        const url = businessId
            ? `${window.location.origin}/business-details/${businessId}`
            : window.location.href;

        await navigator.clipboard.writeText(url);
        toast.success('Profile link copied to clipboard');
    };

    const handleInstagramLogin = () => {
        const clientId = IG_APP_ID;
        const redirectUri = 'https://next-salon.web.app/upload-from-instagram';
        const state = Math.random().toString(36).substring(7);

        const authUrl = new URL('https://www.instagram.com/oauth/authorize');
        authUrl.searchParams.append('client_id', clientId);
        authUrl.searchParams.append('redirect_uri', redirectUri);
        authUrl.searchParams.append(
            'scope',
            'instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments,instagram_business_content_publish,instagram_business_manage_insights'
        );
        authUrl.searchParams.append('response_type', 'code');
        authUrl.searchParams.append('state', state);

        window.location.href = authUrl.toString();
    };

    return (
        <>
            {!businessDetails || fetchLoading ? (
                <Loading />
            ) : (
                <div className={`container-fluid`}>
                    <div className={`row`}>
                        <div className={`col-12 px-0 bg-ff br-top-left-22`}>
                            <Navbar />

                            <AddProductForm
                                className={`border-1-md-e1e6ef br-24 mt-0 mx-md-24 mb-20`}
                            >
                                <h6
                                    className={`m-0 pt-60 pb-md-40 f-28 fw-normal poly c-0f151d text-center`}
                                >
                                    Business details
                                </h6>

                                <form onSubmit={handleSubmit}>
                                    <BasicFormWrapper>
                                        <div className="add-product-block max-w-605 mx-auto bg-white border-1-md-e1e6ef br-24 pt-50 pb-60 mb-50">
                                            <div
                                                className={`max-w-485 mx-auto`}
                                            >
                                                <div className="d-flex flex-row-reverse gap-2">
                                                    {' '}
                                                    <div className="border-card-pill mb-3">
                                                        <div
                                                            className="py-1 px-2 "
                                                            onClick={
                                                                handleCopyClick
                                                            }
                                                        >
                                                            <span
                                                                className="poppins f-14 lh-20 color-primary"
                                                                role="button"
                                                            >
                                                                Referral Link
                                                            </span>
                                                            <span className="fw-medium ps-2">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 448 512"
                                                                    width="12"
                                                                    height="12"
                                                                >
                                                                    <path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="border-card-pill mb-3">
                                                        <div
                                                            className="py-1 px-2 "
                                                            onClick={
                                                                handleShareProfile
                                                            }
                                                        >
                                                            <span
                                                                title="Share your profile link"
                                                                className="poppins f-14 lh-20 color-primary"
                                                                role="button"
                                                            >
                                                                Share profile
                                                            </span>
                                                            <span className="fw-medium ps-2">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 448 512"
                                                                    width="12"
                                                                    height="12"
                                                                >
                                                                    <path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
                                                                </svg>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <h6
                                                    className={`m-0 pb-12 f-22 fw-normal poly c-0f151d`}
                                                >
                                                    Business info
                                                </h6>

                                                <span
                                                    className={`d-block f-14 fw-normal text-gray pb-24 poppins`}
                                                >
                                                    Your business name is
                                                    displayed across many areas
                                                    including on your online
                                                    booking profile, sales
                                                    receipts and messages to
                                                    clients
                                                </span>
                                                <div className="pb-16">
                                                    <h6 className="f-14 fw-normal poppins text-gray">
                                                        Business name
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </h6>
                                                    <label
                                                        className="label-search w-100"
                                                        htmlFor="header-search"
                                                    >
                                                        <input
                                                            className="input-search ps-0"
                                                            type="text"
                                                            name="name"
                                                            value={name}
                                                            placeholder="Business name"
                                                            onChange={(e) => {
                                                                const newName =
                                                                    e.target
                                                                        .value;
                                                                const normalizedNewName =
                                                                    newName
                                                                        .toLowerCase()
                                                                        .replace(
                                                                            /\s+/g,
                                                                            '-'
                                                                        );
                                                                const normalizedBusinessNames =
                                                                    businessNames.map(
                                                                        (bn) =>
                                                                            bn
                                                                                .toLowerCase()
                                                                                .replace(
                                                                                    /\s+/g,
                                                                                    '-'
                                                                                )
                                                                    );

                                                                setName(
                                                                    newName
                                                                );

                                                                if (
                                                                    userData?.business?.name
                                                                        ?.toLowerCase()
                                                                        .replace(
                                                                            /\s+/g,
                                                                            '-'
                                                                        ) ===
                                                                    normalizedNewName
                                                                ) {
                                                                    setErrors(
                                                                        (
                                                                            prevErrors
                                                                        ) => {
                                                                            const {
                                                                                name,
                                                                                ...rest
                                                                            } =
                                                                                prevErrors;
                                                                            return rest;
                                                                        }
                                                                    );
                                                                    return;
                                                                }

                                                                if (
                                                                    normalizedBusinessNames.includes(
                                                                        normalizedNewName
                                                                    )
                                                                ) {
                                                                    setErrors(
                                                                        (
                                                                            prevErrors
                                                                        ) => ({
                                                                            ...prevErrors,
                                                                            name: 'This business name already exists.',
                                                                        })
                                                                    );
                                                                } else {
                                                                    setErrors(
                                                                        (
                                                                            prevErrors
                                                                        ) => {
                                                                            const {
                                                                                name,
                                                                                ...rest
                                                                            } =
                                                                                prevErrors;
                                                                            return rest;
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </label>
                                                    {errors.name && (
                                                        <p className="text-danger fs-12">
                                                            {errors.name}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className="mb-3">
                                                    <h6 className="f-14 fw-normal poppins text-gray">
                                                        About
                                                    </h6>
                                                    <label
                                                        className="w-100"
                                                        htmlFor="about"
                                                    >
                                                        <ReactQuill
                                                            id="about"
                                                            theme="snow"
                                                            value={about}
                                                            onChange={setAbout}
                                                            placeholder="Enter a short description here..."
                                                            style={{
                                                                height: '200px',
                                                                maxHeight:
                                                                    '400px',
                                                            }}
                                                            modules={modules}
                                                            formats={formats}
                                                        />
                                                    </label>
                                                </div>

                                                <div className={`pb-16`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Email address
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </h6>
                                                    <label
                                                        className={`label-search w-100`}
                                                        htmlFor={'email'}
                                                    >
                                                        <input
                                                            className={`input-search ps-0`}
                                                            type="text"
                                                            name="email"
                                                            value={email}
                                                            placeholder={`Enter business email address`}
                                                            onChange={(e) =>
                                                                setEmail(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            disabled
                                                        />
                                                    </label>
                                                </div>

                                                <div className={`pb-16`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Contact number
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </h6>
                                                    <div className="input-group input-filed">
                                                        <span
                                                            className="input-group-text border-0 py-0 ps-0 bg-transparent"
                                                            id="basic-addon1"
                                                        >
                                                            <div className="dropdown">
                                                                <button
                                                                    className="btn btn-country-num dropdown-toggle"
                                                                    type="button"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <div className="container-fluid">
                                                                        <div className="row">
                                                                            <div className="col px-0">
                                                                                {
                                                                                    countryCode
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </button>
                                                                <div className="dropdown-menu country-dropdown-menu">
                                                                    <input
                                                                        className="country-dropdown-input"
                                                                        type="text"
                                                                        placeholder="Search for a country..."
                                                                        value={
                                                                            searchTerm
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            setSearchTerm(
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                            )
                                                                        }
                                                                    />
                                                                    {filteredOptions.map(
                                                                        (
                                                                            _country
                                                                        ) => (
                                                                            <p
                                                                                key={
                                                                                    _country.label
                                                                                }
                                                                                className="dropdown-item cp"
                                                                                onClick={() =>
                                                                                    handleCountryCodeClick(
                                                                                        _country
                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    _country.flag
                                                                                }{' '}
                                                                                {
                                                                                    _country.label
                                                                                }{' '}
                                                                                {
                                                                                    _country.code
                                                                                }
                                                                            </p>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </span>
                                                        <input
                                                            type="number"
                                                            name="phone"
                                                            value={phone}
                                                            onChange={(e) =>
                                                                setPhone(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            className="form-control border-0 py-0 box-shadow-0"
                                                            placeholder={`Enter business mobile number`}
                                                        />
                                                    </div>
                                                    {errors.phone && (
                                                        <p className="text-danger fs-12">
                                                            {errors.phone}
                                                        </p>
                                                    )}
                                                </div>

                                                <h6
                                                    className={`f-14 fw-normal poppins text-gray`}
                                                >
                                                    Edit Pictures
                                                </h6>
                                                <div className={`pb-16`}>
                                                    <input
                                                        className="d-none"
                                                        type="file"
                                                        id="fileInput"
                                                        accept="image/jpeg, image/png, image/jpg"
                                                        multiple
                                                        onChange={
                                                            handleImageChange
                                                        }
                                                    />
                                                    <div className="d-flex flex-row flex-wrap gap-2">
                                                        <div className="image-dimentions doted-border bg-white p-1 d-flex flex-column justify-content-center align-items-center gap-1">
                                                            <label
                                                                htmlFor="fileInput"
                                                                role="button"
                                                                className=" d-flex justify-content-center align-items-center gap-1 poppins text-center p-1 m-0 rounded-pill fs-9"
                                                            >
                                                                {' '}
                                                                <span className="pt-1 fs-11">
                                                                    <div className="mb-2">
                                                                        <img
                                                                            src={
                                                                                plusIcon
                                                                            }
                                                                            height={
                                                                                25
                                                                            }
                                                                            width={
                                                                                25
                                                                            }
                                                                            alt="icon"
                                                                        />
                                                                    </div>
                                                                    Add Image
                                                                    from Gallery
                                                                    <br />
                                                                    or{' '}
                                                                    <button
                                                                        type="button"
                                                                        className="border-0 bg-transparent text-decoration-underline"
                                                                        onClick={
                                                                            handleInstagramLogin
                                                                        }
                                                                        // href={`https://api.instagram.com/oauth/authorize?client_id=${IG_APP_ID}&redirect_uri=${BASEURL}/upload-from-instagram&scope=user_profile,user_media&response_type=code`}
                                                                    >
                                                                        Instagram
                                                                    </button>
                                                                </span>
                                                            </label>
                                                        </div>

                                                        {images.map(
                                                            (img, index) => (
                                                                <div
                                                                    className="image-dimentions position-relative"
                                                                    key={index}
                                                                >
                                                                    <div className="cancel-pic">
                                                                        <button
                                                                            type="button"
                                                                            className="delete-img-btn"
                                                                            disabled={
                                                                                updateLoading
                                                                            }
                                                                            onClick={() =>
                                                                                handleRemoveImage(
                                                                                    img.id,
                                                                                    index
                                                                                )
                                                                            }
                                                                        >
                                                                            {updateLoading ? (
                                                                                <Spin />
                                                                            ) : (
                                                                                <svg
                                                                                    width="14"
                                                                                    height="16"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    viewBox="0 0 448 512"
                                                                                >
                                                                                    <path
                                                                                        d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1 -32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.7 23.7 0 0 0 -21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0 -16-16z"
                                                                                        fill="red"
                                                                                    />
                                                                                </svg>
                                                                            )}
                                                                        </button>
                                                                    </div>
                                                                    <img
                                                                        src={
                                                                            img.photo_path ||
                                                                            img.previewPic
                                                                        }
                                                                        alt="image"
                                                                        className="w-100 h-100 object-fit-fill"
                                                                    />
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                    {errors.images && (
                                                        <p className="text-danger fs-12">
                                                            {errors.images}
                                                        </p>
                                                    )}
                                                </div>

                                                <div
                                                    className={`col-md-12 pb-20`}
                                                >
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Business Location
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </h6>
                                                    <label
                                                        className={`label-search w-100`}
                                                    >
                                                        <Autocomplete
                                                            onLoad={(
                                                                autocomplete
                                                            ) => {
                                                                setData(
                                                                    autocomplete
                                                                );
                                                            }}
                                                            onPlaceChanged={() => {
                                                                handleLocationLatLng();
                                                            }}
                                                        >
                                                            <input
                                                                type="text"
                                                                value={
                                                                    location ===
                                                                    'null'
                                                                        ? null
                                                                        : location
                                                                }
                                                                onChange={(e) =>
                                                                    setLocation(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                                className="input-search ps-0"
                                                                placeholder="Choose location"
                                                                disabled={
                                                                    isOnline
                                                                }
                                                            />
                                                        </Autocomplete>
                                                    </label>

                                                    {errors.location && (
                                                        <p className="text-danger fs-12">
                                                            {errors.location}
                                                        </p>
                                                    )}

                                                    {/* <div
                                                        className={`col-md-12 mt-3`}
                                                    >
                                                        <div className="form-check d-flex align-items-md-start align-items-center">
                                                            <input
                                                                className="form-check-input check-box-custom cp"
                                                                type="checkbox"
                                                                checked={
                                                                    isOnline
                                                                }
                                                                onChange={
                                                                    handleIsOnline
                                                                }
                                                            />
                                                            <label className="form-check-label c-667085 poppins f-14 fw-normal lh-23 ps-2">
                                                                I don’t have a
                                                                business address
                                                                (mobile and
                                                                online services
                                                                only)
                                                            </label>
                                                        </div>
                                                    </div> */}
                                                </div>

                                                {/* Cancelation Policy */}
                                                <div
                                                    className={`border-b-1-e1e6ef my-30`}
                                                />
                                                <h6
                                                    className={`m-0 pb-12 f-22 fw-normal poly c-0f151d`}
                                                >
                                                    Cancelation Policy
                                                </h6>

                                                <div className={` `}>
                                                    <h6
                                                        className={`f-14 mt-2 fw-normal poppins text-gray`}
                                                    >
                                                        Cancellation Type
                                                    </h6>
                                                    <label
                                                        className={`label-search position-relative
                                                        w-100 h__48 d-flex align-items-center cp relative`}
                                                        onClick={
                                                            toggleCancellationType
                                                        }
                                                        ref={cancellationRef}
                                                    >
                                                        {cancellationType ? (
                                                            capitalizeFirstLetter(
                                                                cancellationType
                                                            )
                                                        ) : (
                                                            <span className="text-gray">
                                                                {' '}
                                                                Choose Type
                                                            </span>
                                                        )}

                                                        {isCancellationTypeOpen && (
                                                            <div
                                                                className="cancellation-type-dropdown pt-3"
                                                                // ref={
                                                                //     cancellationRef
                                                                // }
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.stopPropagation();
                                                                }}
                                                            >
                                                                {/* Your dropdown options go here */}
                                                                {cancellationTypes?.map(
                                                                    (
                                                                        type,
                                                                        idx
                                                                    ) => {
                                                                        return (
                                                                            <div
                                                                                className={`d-flex flex-column cancellation-type-dropdown-item poppins pb-2 px-2 ${
                                                                                    idx +
                                                                                        1 !=
                                                                                    cancellationTypes.length
                                                                                        ? 'cancellation-border-bottom mb-2'
                                                                                        : 'mb-1'
                                                                                }`}
                                                                                key={
                                                                                    idx
                                                                                }
                                                                                onClick={() => {
                                                                                    setCancellationType(
                                                                                        type?.title
                                                                                    );
                                                                                    setCancellationTypeOpen(
                                                                                        false
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <span className="cancellation-type-dropdown-item-title">
                                                                                    {' '}
                                                                                    {capitalizeFirstLetter(
                                                                                        type?.title
                                                                                    )}
                                                                                </span>
                                                                                <span className="cancellation-type-dropdown-item-description">
                                                                                    {
                                                                                        type?.description
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        )}
                                                    </label>
                                                </div>

                                                {/* Payment Methods */}
                                                <div className="border-b-1-e1e6ef my-30" />

                                                <h6 className="m-0 pb-12 f-22 fw-normal poly c-0f151d">
                                                    Accepted Payment Methods
                                                </h6>
                                                <p className="f-14 fw-normal poppins text-gray mb-3">
                                                    Select which payment methods
                                                    you accept for appointments
                                                </p>

                                                <div className="payment-methods-selection">
                                                    <div className="row g-3">
                                                        <div className="col-md-4">
                                                            <div
                                                                className={`payment-method-option ${
                                                                    paymentMethods ===
                                                                    'card'
                                                                        ? 'payment-method-selected'
                                                                        : ''
                                                                }`}
                                                                onClick={() =>
                                                                    handlePaymentMethodToggle(
                                                                        'card'
                                                                    )
                                                                }
                                                                role="button"
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                <div className="custom-radio">
                                                                    <svg
                                                                        width="10"
                                                                        height="10"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="3"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                                    </svg>
                                                                </div>
                                                                <div className="payment-method-icon">
                                                                    <svg
                                                                        width="22"
                                                                        height="22"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <rect
                                                                            x="2"
                                                                            y="5"
                                                                            width="20"
                                                                            height="14"
                                                                            rx="2"
                                                                            ry="2"
                                                                        ></rect>
                                                                        <line
                                                                            x1="2"
                                                                            y1="10"
                                                                            x2="22"
                                                                            y2="10"
                                                                        ></line>
                                                                    </svg>
                                                                </div>
                                                                <h5>
                                                                    Card Only
                                                                </h5>
                                                                <p>
                                                                    Accept only
                                                                    credit and
                                                                    debit card
                                                                    payments
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div
                                                                className={`payment-method-option ${
                                                                    paymentMethods ===
                                                                    'cash'
                                                                        ? 'payment-method-selected'
                                                                        : ''
                                                                }`}
                                                                onClick={() =>
                                                                    handlePaymentMethodToggle(
                                                                        'cash'
                                                                    )
                                                                }
                                                                role="button"
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                <div className="custom-radio">
                                                                    <svg
                                                                        width="10"
                                                                        height="10"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="3"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                                    </svg>
                                                                </div>
                                                                <div className="payment-method-icon">
                                                                    <svg
                                                                        width="22"
                                                                        height="22"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <rect
                                                                            x="2"
                                                                            y="6"
                                                                            width="20"
                                                                            height="12"
                                                                            rx="2"
                                                                        ></rect>
                                                                        <circle
                                                                            cx="12"
                                                                            cy="12"
                                                                            r="2"
                                                                        ></circle>
                                                                        <path d="M6 12h.01M18 12h.01"></path>
                                                                    </svg>
                                                                </div>
                                                                <h5>
                                                                    Cash Only
                                                                </h5>
                                                                <p>
                                                                    Accept only
                                                                    cash after
                                                                    service
                                                                    completion
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div
                                                                className={`payment-method-option ${
                                                                    paymentMethods ===
                                                                    'both'
                                                                        ? 'payment-method-selected'
                                                                        : ''
                                                                }`}
                                                                onClick={() =>
                                                                    handlePaymentMethodToggle(
                                                                        'both'
                                                                    )
                                                                }
                                                                role="button"
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                <div className="custom-radio">
                                                                    <svg
                                                                        width="10"
                                                                        height="10"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="3"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                                    </svg>
                                                                </div>
                                                                <div className="payment-method-icon">
                                                                    <svg
                                                                        width="22"
                                                                        height="22"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <rect
                                                                            x="2"
                                                                            y="4"
                                                                            width="20"
                                                                            height="12"
                                                                            rx="2"
                                                                        ></rect>
                                                                        <path d="M12 11h6"></path>
                                                                        <rect
                                                                            x="2"
                                                                            y="11"
                                                                            width="16"
                                                                            height="9"
                                                                            rx="2"
                                                                        ></rect>
                                                                    </svg>
                                                                </div>
                                                                <h5>Both</h5>
                                                                <p>
                                                                    Accept both
                                                                    card and
                                                                    cash
                                                                    payments
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Cancelation Policy */}
                                                <div className="border-b-1-e1e6ef my-30" />

                                                <BookingPolicySection
                                                    policies={policies}
                                                    setPolicies={setPolicies}
                                                    bookingPeriod={
                                                        bookingPeriod
                                                    }
                                                    setBookingPeriod={
                                                        setBookingPeriod
                                                    }
                                                    bufferTime={bufferTime}
                                                    setBufferTime={
                                                        setBufferTime
                                                    }
                                                    depositPercentage={
                                                        depositPercentage
                                                    }
                                                    setDepositPercentage={
                                                        setDepositPercentage
                                                    }
                                                    modules={modules}
                                                    formats={formats}
                                                />

                                                <div className={`mb-20`}>
                                                    <h6
                                                        className={`f-14 fw-normal poppins text-gray`}
                                                    >
                                                        Opening time
                                                    </h6>
                                                    <div className="border rounded">
                                                        <div className="m-3">
                                                            <div
                                                                className="d-flex align-items-center justify-content-between mb-4 p-3 bg-light rounded-3"
                                                                style={{
                                                                    border: '1px solid #e1e6ef',
                                                                }}
                                                            >
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <svg
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                                            stroke="#2b5c35"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M12 6V12L16 14"
                                                                            stroke="#2b5c35"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                    <div>
                                                                        <p
                                                                            className="m-0 fw-600 poppins f-14 text-dark select-none"
                                                                            style={{
                                                                                textAlign:
                                                                                    'left',
                                                                            }}
                                                                        >
                                                                            Apply
                                                                            same
                                                                            time
                                                                            to
                                                                            all
                                                                            days
                                                                        </p>
                                                                        <p
                                                                            className="m-0 poppins f-12 text-gray select-none"
                                                                            style={{
                                                                                textAlign:
                                                                                    'left',
                                                                            }}
                                                                        >
                                                                            Copy
                                                                            opening
                                                                            timings
                                                                            of
                                                                            the
                                                                            edited
                                                                            day
                                                                            to
                                                                            all
                                                                            other
                                                                            open
                                                                            days
                                                                            automatically
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex align-items-center">
                                                                    <Switch
                                                                        checked={
                                                                            applyAll
                                                                        }
                                                                        onChange={(
                                                                            checked
                                                                        ) =>
                                                                            setApplyAll(
                                                                                checked
                                                                            )
                                                                        }
                                                                        style={{
                                                                            backgroundColor:
                                                                                applyAll
                                                                                    ? '#2b5c35'
                                                                                    : '#d9d9d9',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {Object.keys(
                                                                routine
                                                            ).map((day) =>
                                                                handleRoutine(
                                                                    day
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={`mb-20`}>
                                                    <label
                                                        htmlFor="businessName"
                                                        className="form-label f-14 fw-normal poppins text-gray"
                                                    >
                                                        Services
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </label>
                                                    <div
                                                        className={`d-flex flex-wrap position-relative`}
                                                    >
                                                        {SERVICES.map(
                                                            (
                                                                service,
                                                                index
                                                            ) => (
                                                                <div
                                                                    key={index}
                                                                    className={`custom-service-col`}
                                                                    title={
                                                                        service.name
                                                                    }
                                                                >
                                                                    <label className="checkbox-container">
                                                                        <input
                                                                            className={`step-input`}
                                                                            checked={selectedServices.includes(
                                                                                service.name
                                                                            )}
                                                                            onChange={() =>
                                                                                handleServiceChange(
                                                                                    service.name
                                                                                )
                                                                            }
                                                                            type="checkbox"
                                                                        />
                                                                        <div
                                                                            className={`container-fluid pt-32 pb-22 checked-color`}
                                                                        >
                                                                            <div
                                                                                className={`row justify-content-center h-84`}
                                                                            >
                                                                                <div
                                                                                    className={`col-12 px-0 text-center`}
                                                                                >
                                                                                    <SVG
                                                                                        icon={
                                                                                            service.icon
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                                <div
                                                                                    className={`col-12 px-0 w-200`}
                                                                                >
                                                                                    <h6
                                                                                        className={`mb-0 mx-auto checked-text p-2 responsive-service-text`}
                                                                                        style={{
                                                                                            fontSize:
                                                                                                '11px',
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            service.name
                                                                                        }
                                                                                    </h6>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <span
                                                                            className={`bg-checkbox`}
                                                                        >
                                                                            <span className="checkmark"></span>
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            )
                                                        )}
                                                        {errors.services && (
                                                            <p className="text-danger fs-12">
                                                                {
                                                                    errors.services
                                                                }
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                <SubscriptionSection
                                                    subscriptionInfo={
                                                        subscriptionInfo
                                                    }
                                                    subscriptionStatusLabel={
                                                        subscriptionStatusLabel
                                                    }
                                                    subscriptionEndDate={
                                                        subscriptionEndDate
                                                    }
                                                    currentPlan={currentPlan}
                                                    userData={userData}
                                                    isSubscriptionModalOpen={
                                                        isSubscriptionModalOpen
                                                    }
                                                    setIsSubscriptionModalOpen={
                                                        setIsSubscriptionModalOpen
                                                    }
                                                    isCancelling={isCancelling}
                                                    handleCancelSubscription={
                                                        handleCancelSubscription
                                                    }
                                                    subscriptionStatusLoading={
                                                        subscriptionStatusLoading
                                                    }
                                                    resumeSubscriptionLoading={
                                                        resumeSubscriptionLoading
                                                    }
                                                    cancelSubscriptionLoading={
                                                        cancelSubscriptionLoading
                                                    }
                                                    handleResumeSubscription={
                                                        handleResumeSubscription
                                                    }
                                                    onOpenChangeCardModal={() =>
                                                        setIsChangeCardModalVisible(
                                                            true
                                                        )
                                                    }
                                                />

                                                <div
                                                    className={`border-b-1-e1e6ef my-30`}
                                                />

                                                <OnlineLinksSection
                                                    website={website}
                                                    setWebsite={setWebsite}
                                                    fb={fb}
                                                    setFb={setFb}
                                                    insta={insta}
                                                    setInsta={setInsta}
                                                    errors={errors}
                                                />
                                            </div>

                                            <div className="d-flex w-100 justify-content-end">
                                                <button
                                                    type="submit"
                                                    className={`btn btn-prim px-4`}
                                                    disabled={updateLoading}
                                                >
                                                    {updateLoading ? (
                                                        <Spin />
                                                    ) : (
                                                        'Save'
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </BasicFormWrapper>
                                </form>
                            </AddProductForm>
                        </div>
                    </div>

                    {isModalOpen && (
                        <div className={`modal instagram-modal`}>
                            <UploadFromInsta
                                instaImages={instaImages}
                                onClose={() => setIsModalOpen(false)}
                            />
                        </div>
                    )}

                    <ChangeCardModal
                        visible={isChangeCardModalVisible}
                        onClose={() => setIsChangeCardModalVisible(false)}
                    />
                </div>
            )}
        </>
    );
};

export default Setting;
